module.exports = __webpack_public_path__ + "img/lunartic-in-moon.deb6c940.webp";